import { render, staticRenderFns } from "./addtemplate.vue?vue&type=template&id=f1af567e"
import script from "./addtemplate.vue?vue&type=script&lang=js"
export * from "./addtemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports